import 'jspdf-autotable'
import Loading from "@/components/widgets/Loading.vue"

export default {
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      company: {
        company_name: '',
        address: '',
        tax_number: '',
        phone_number: '',
      },
      document: {
        document_no: '',
        created_at: '',
        paid_at: '',
        quotation_no: '',
        creator: '',
        bank_account: '',
        note: '',
      },
      customer: {
        code: '',
        name: '',
        address: '',
        tax_id: '',
        phone_number: ''
      },
      items: [],
      deposit: 0,
      // VAT (ตรงกับ computeDepositVat ฝั่ง backend / PDF)
      taxType: 0,
      beforeVat: 0,
      vat: 0,
      grandTotal: 0
    }
  },
  watch: {
    'data'(newValue, oldValue) {
      if (newValue) {
        const company = newValue.branch_detail

        if (company) {
          this.company.company_name = company.company_name
          this.company.address = company.address
          this.company.tax_number = company.tax_id
          this.company.phone_number = company.phone_number
        }        

        this.document.document_no = newValue.document_no
        this.document.created_at = newValue.created_at
        this.document.paid_at = newValue.paid_at
        this.document.quotation_no = newValue.quotation ? newValue.quotation.quotation_no : '-'
        this.document.creator = newValue.creator_detail ? newValue.creator_detail?.name : '-'
        this.document.bank_account = newValue.bank_account ? newValue.bank_account.account_number + ' ' + newValue.bank_account.account_name + ' ' + newValue.bank_account.account_bank : '-'
        this.document.note = newValue.note || ''

        // const bill = newValue.quotation
        // if (bill) {
          this.customer.code = newValue.customer.code
          this.customer.name = newValue.customer.name
          this.customer.company_name = newValue.customer.company_name
          this.customer.address = newValue.customer.address
          this.customer.tax_id = newValue.customer.tax_id
          this.customer.phone_number = newValue.customer.phone_number
        // }

        this.items.push(newValue.quotation)
        this.deposit = newValue.amount

        // VAT: ใช้ค่าที่เก็บไว้ ถ้าเป็น null (เอกสารเก่า) คำนวณ on-the-fly
        this.taxType = Number(newValue.tax_type) || 0
        if (newValue.grand_total != null) {
          this.beforeVat = Number(newValue.before_vat) || 0
          this.vat = Number(newValue.vat) || 0
          this.grandTotal = Number(newValue.grand_total) || 0
        } else {
          const b = this.computeDepositVat(this.taxType, Number(newValue.amount) || 0)
          this.beforeVat = b.beforeVat
          this.vat = b.vat
          this.grandTotal = b.grandTotal
        }
      }
    }
  },
  methods: {
    // คำนวณ VAT (สูตรตรงกับ computeDepositVat ฝั่ง backend)
    computeDepositVat(taxType, amount) {
      const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100
      amount = r2(amount)
      if (Number(taxType) === 2) {
        const beforeVat = r2(amount * 100 / 107)
        return { beforeVat, vat: r2(amount - beforeVat), grandTotal: amount }
      }
      if (Number(taxType) === 1) {
        const vat = r2(amount * 0.07)
        return { beforeVat: amount, vat, grandTotal: r2(amount + vat) }
      }
      return { beforeVat: amount, vat: 0, grandTotal: amount }
    },
    async onInitIFrame() {
      this.loading = true
      const result = await this.$axios.get(
        this.$host + "/api/v1/deposit-pdf/"+ this.$route.params?.id,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob"
        }
      )
      const blob = new Blob([result.data], {type: 'application/pdf'});
      const objectUrl = URL.createObjectURL(blob)
      window.open(objectUrl, '_blank')
      this.loading = false
    }
  }
}
